import React, { useState } from "react";
import {
  Box, Typography, Paper, List, ListItem, ListItemIcon, ListItemText, Button, Chip, Divider, Link,
  Dialog, DialogTitle, DialogContent, DialogActions, TextField, MenuItem, Select, InputLabel, FormControl, Checkbox, FormGroup, FormControlLabel
} from "@mui/material";
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import EuroIcon from '@mui/icons-material/Euro';
import SecurityIcon from '@mui/icons-material/Security';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PaidIcon from '@mui/icons-material/Paid';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import PlaceIcon from '@mui/icons-material/Place';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import ScheduleIcon from '@mui/icons-material/Schedule';
import LanguageIcon from '@mui/icons-material/Language';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import VoiceChatIcon from '@mui/icons-material/VoiceChat';
import FacebookIcon from '@mui/icons-material/Facebook';

const days = [
  { value: "Poniedziałek", label: "Poniedziałek", jsDay: 1 },
  { value: "Wtorek", label: "Wtorek", jsDay: 2 },
  { value: "Środa", label: "Środa", jsDay: 3 },
  { value: "Czwartek", label: "Czwartek", jsDay: 4 },
  { value: "Piątek", label: "Piątek", jsDay: 5 },
];

const timeSlots = [
  "15:00", "15:20", "15:40",
  "16:00", "16:20", "16:40",
  "17:00", "17:20", "17:40",
  "18:00", "18:20", "18:40",
  "19:00", "19:20", "19:40",
  "20:00"
];

const platformsList = [
  { label: "WhatsApp", value: "WhatsApp", icon: <WhatsAppIcon sx={{ color: "#25D366" }} /> },
  { label: "Skype", value: "Skype", icon: <VoiceChatIcon sx={{ color: "#00aff0" }} /> },
  { label: "Messenger", value: "Messenger", icon: <FacebookIcon sx={{ color: "#4267B2" }} /> },
];

export default function DriverPl() {
  const [open, setOpen] = useState(false);
  const [selectedDay, setSelectedDay] = useState("");
  const [selectedTime, setSelectedTime] = useState("");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);
  const [platforms, setPlatforms] = useState([]);
  const [contact, setContact] = useState("");

  // Get today's JS day (0=Sunday, 1=Monday, ..., 6=Saturday)
  const todayJsDay = new Date().getDay();

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setSelectedDay("");
    setSelectedTime("");
    setMessage("");
    setSending(false);
    setPlatforms([]);
    setContact("");
  };

  const handlePlatformChange = (event) => {
    const { value, checked } = event.target;
    setPlatforms(prev =>
      checked ? [...prev, value] : prev.filter(p => p !== value)
    );
  };

  const handleSend = () => {
    setSending(true);
    const subject = encodeURIComponent("Rezerwacja rozmowy - kierowca autobusu");
    const body = encodeURIComponent(
      `Wybrany termin: ${selectedDay}, godzina: ${selectedTime}\n` +
      `Preferowana platforma: ${platforms.join(", ")}\n` +
      `Login/E-mail do kontaktu: ${contact}\n\n` +
      `Wiadomość: ${message}`
    );
    window.location.href = `mailto:ollo7776@gmail.com?subject=${subject}&body=${body}`;
    setTimeout(() => {
      setSending(false);
      setOpen(false);
    }, 1000);
  };

  return (
    <Box sx={{ maxWidth: 700, mx: "auto", my: 4, p: 2 }}>
      <Paper elevation={4} sx={{ p: 3, mb: 3, background: "linear-gradient(135deg, #e3f2fd 0%, #fff 100%)" }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
          <DirectionsBusIcon sx={{ fontSize: 48, color: "#1976d2" }} />
          <Typography variant="h4" component="h1" sx={{ fontWeight: "bold", color: "#1976d2" }}>
            Praca dla kierowcy autobusu – Frankfurt Höchst
          </Typography>
        </Box>
        <img
          src={require('./images/20250807_112514.jpg')}
          alt="Linienbus in Frankfurt"
          style={{ width: "100%", borderRadius: 12, marginBottom: 24, maxHeight: 260, objectFit: "cover" }}
        />
        <Typography variant="h6" sx={{ mb: 2, color: "#388e3c" }}>
          Szukasz stabilnej pracy jako kierowca autobusu w Niemczech?
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Dołącz do nas i pracuj w sercu Frankfurtu! <br />
          Jesteśmy renomowaną i stabilną firmą transportową zlokalizowaną we Frankfurcie nad Menem. Mamy dla Ciebie idealną propozycję pracy, jeśli posiadasz prawo jazdy kat. D i doświadczenie w prowadzeniu autobusów miejskich.
        </Typography>
        <Divider sx={{ my: 2 }} />
        <Typography variant="h6" sx={{ mb: 1, color: "#1976d2" }}>
          Co zyskasz, dołączając do naszego zespołu?
        </Typography>
        <List>
          <ListItem>
            <ListItemIcon><EuroIcon color="success" /></ListItemIcon>
            <ListItemText
              primary="Atrakcyjne warunki finansowe"
              secondary="Stabilne i konkurencyjne stawki godzinowe, wysokie dodatki za nadgodziny (25%), noc (25%), soboty (20%), niedziele (50%) oraz święta (100%)."
            />
          </ListItem>
          <ListItem>
            <ListItemIcon><SecurityIcon color="primary" /></ListItemIcon>
            <ListItemText
              primary="Pewność zatrudnienia"
              secondary="Umowa o pracę na dogodnych warunkach."
            />
          </ListItem>
          <ListItem>
            <ListItemIcon><PaidIcon color="secondary" /></ListItemIcon>
            <ListItemText
              primary="Terminowe wynagrodzenie"
              secondary="Gwarantujemy punktualną wypłatę pensji, co daje Ci poczucie bezpieczeństwa finansowego."
            />
          </ListItem>
          <ListItem>
            <ListItemIcon><BeachAccessIcon color="info" /></ListItemIcon>
            <ListItemText
              primary="Korzystny system urlopowy"
              secondary={
                <>
                  Już po pierwszym miesiącu pracy zyskujesz prawo do 2 dni urlopu.<br />
                  Po 6 miesiącach zatrudnienia przysługuje Ci pełen roczny wymiar urlopu.<br />
                  Terminy urlopów są elastyczne i ustalane wspólnie z pracodawcą.
                </>
              }
            />
          </ListItem>
          <ListItem>
            <ListItemIcon><EmojiEventsIcon color="warning" /></ListItemIcon>
            <ListItemText
              primary="Dodatkowe premie"
              secondary="Za pracę w zaplanowanym dniu wolnym przewidziane są dodatkowe gratyfikacje."
            />
          </ListItem>
        </List>
        <Divider sx={{ my: 2 }} />
        <Typography variant="h6" sx={{ mb: 1, color: "#1976d2" }}>
          Idealne warunki pracy dla Ciebie:
        </Typography>
        <List>
          <ListItem>
            <ListItemIcon><PlaceIcon color="error" /></ListItemIcon>
            <ListItemText
              primary="Praca w jednym miejscu"
              secondary="Pracuj w Höchst, jednej z dzielnic Frankfurtu, i naucz się zaledwie kilku kluczowych linii."
            />
          </ListItem>
          <ListItem>
            <ListItemIcon><SupportAgentIcon color="primary" /></ListItemIcon>
            <ListItemText
              primary="Wsparcie na każdym etapie"
              secondary="Zapewniamy pełną pomoc na etapie wdrożenia, w tym wsparcie doświadczonych kolegów."
            />
          </ListItem>
          <ListItem>
            <ListItemIcon><ScheduleIcon color="success" /></ListItemIcon>
            <ListItemText
              primary="Elastyczny grafik"
              secondary="Oferujemy elastyczne systemy pracy (np. 5+2, 4+1+4+2) oraz różne godziny rozpoczęcia dnia pracy (wczesny, środkowy, późny)."
            />
          </ListItem>
        </List>
        <Divider sx={{ my: 2 }} />
        <Typography variant="h6" sx={{ mb: 1, color: "#1976d2" }}>
          Kogo szukamy?
        </Typography>
        <List>
          <ListItem>
            <ListItemIcon><DirectionsBusIcon color="primary" /></ListItemIcon>
            <ListItemText
              primary="Odpowiedzialnych kierowców"
              secondary="Prawo jazdy kat. D z kodem 95 i doświadczenie w jeździe miejskiej."
            />
          </ListItem>
          <ListItem>
            <ListItemIcon><LanguageIcon color="action" /></ListItemIcon>
            <ListItemText
              primary="Podstawowa znajomość języka niemieckiego"
              secondary="Pozwoli na swobodną komunikację."
            />
          </ListItem>
        </List>
        <Divider sx={{ my: 2 }} />
        <Typography variant="body1" sx={{ mb: 2 }}>
          Chcesz dowiedzieć się więcej?<br />
          Skontaktuj się z nami już dziś! Możemy porozmawiać o szczegółach w Twoim ojczystym języku – mówimy po polsku.
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Umów się na bezpłatną i niezobowiązującą rozmowę przez:
        </Typography>
        <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
          <Chip icon={<WhatsAppIcon sx={{ color: "#25D366" }} />} label="WhatsApp" color="success" />
          <Chip icon={<VoiceChatIcon sx={{ color: "#00aff0" }} />} label="Skype" color="info" />
          <Chip icon={<FacebookIcon sx={{ color: "#4267B2" }} />} label="Messenger" color="primary" />
        </Box>
        <Button
          variant="contained"
          color="success"
          size="large"
          onClick={handleOpen}
          sx={{ mt: 2 }}
        >
          Wyślij zgłoszenie
        </Button>
        {/* POPUP DIALOG */}
        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>Umów termin rozmowy</DialogTitle>
          <DialogContent sx={{ minWidth: 320 }}>
            <FormControl fullWidth sx={{ mt: 2 }}>
              <InputLabel id="day-label">Dzień tygodnia</InputLabel>
              <Select
                labelId="day-label"
                value={selectedDay}
                label="Dzień tygodnia"
                onChange={e => setSelectedDay(e.target.value)}
              >
                {days.map(day => (
                  <MenuItem
                    key={day.value}
                    value={day.value}
                    disabled={day.jsDay === todayJsDay}
                  >
                    {day.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth sx={{ mt: 2 }}>
              <InputLabel id="time-label">Godzina</InputLabel>
              <Select
                labelId="time-label"
                value={selectedTime}
                label="Godzina"
                onChange={e => setSelectedTime(e.target.value)}
                disabled={!selectedDay}
              >
                {timeSlots.map(time => (
                  <MenuItem key={time} value={time}>{time}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl component="fieldset" sx={{ mt: 2 }}>
              <Typography variant="subtitle1" sx={{ mb: 1 }}>Wybierz platformę kontaktu:</Typography>
              <FormGroup row>
                {platformsList.map(p => (
                  <FormControlLabel
                    key={p.value}
                    control={
                      <Checkbox
                        checked={platforms.includes(p.value)}
                        onChange={handlePlatformChange}
                        value={p.value}
                      />
                    }
                    label={
                      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                        {p.icon}
                        {p.label}
                      </Box>
                    }
                  />
                ))}
              </FormGroup>
            </FormControl>
            <TextField
              label="Twój login lub e-mail do kontaktu"
              fullWidth
              required
              sx={{ mt: 2 }}
              value={contact}
              onChange={e => setContact(e.target.value)}
              placeholder="Podaj swój login lub e-mail..."
              error={!contact && sending}
              helperText={!contact && sending ? "To pole jest wymagane" : ""}
            />
            <TextField
              label="Wiadomość (opcjonalnie)"
              multiline
              minRows={2}
              fullWidth
              sx={{ mt: 2 }}
              value={message}
              onChange={e => setMessage(e.target.value)}
              placeholder="Możesz napisać dodatkową wiadomość..."
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleClose}
            >
              Anuluj
            </Button>
            <Button
              variant="contained"
              color="success"
              disabled={
                !selectedDay ||
                !selectedTime ||
                !contact || // <-- Button is inactive if contact is empty
                sending
              }
              onClick={handleSend}
            >
              Wyślij e-mail
            </Button>
          </DialogActions>
        </Dialog>
      </Paper>
    </Box>
  );
}